import { useScrollTop } from '../../hooks/useScrollTop';
const ScrollTop = () => { useScrollTop(); return null; };
export default ScrollTop;
